export default __webpack_public_path__ + "static/media/letter.be3ce24e.svg";